import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

function CommentSection() {
  return (
        <Column as='section'
                spacing={24}
                className={styles.container} >
            <Text size='3xl'
                  fontWeight='bold' >
                정말로 탈퇴하시겠습니까?
            </Text>
            <Text color={colors.gray7}>
                한 번 삭제된 정보는 복구가 불가능합니다.<br/>
                하이픈 페이 잔액이 남아있는 경우 탈퇴가 불가능합니다. 페이 인출 후 탈퇴를 진행해 주세요.<br/>
                재가입은 탈퇴 일로부터 30일 후 가능합니다.
            </Text>
        </Column>
  );
}

export default CommentSection;
